module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-petit-gift-cf45075e6db2212e1f1ae4b78ed6932e.png";